const styles = theme => ({
  root: {
    marginTop: 24,
    fontSize: 14,
  },
  button: {
    alignItems: 'center',
    textAlign: 'center',
    marginLeft: '25%',
    width: '50%',
  },
  space: {
    marginBottom:12,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/LogOut/components/CoreContent/components/Submit/styles.js